export const SocialLinks = {
    twitter: 'https://twitter.com/RealyOfficial',
    discord: 'https://discord.gg/realyofficial',
    telegram: 'https://t.me/realyofficial',
    instagram: 'https://www.instagram.com/realy.pro/',
    medium: 'https://medium.com/@realy'
}
